export default {"src":"/_next/static/media/deco_day_7_glow.925ba4ac.svg","height":68,"width":435,"blurWidth":0,"blurHeight":0};